import {
  defaultAddress,
  setAddress,
  setLoading,
  setSelectedAddress,
  set_OfficeAddress,
} from "../../../../store/Actions/authActions";
import {
  fetchCartItem,
  getProducts,
  selectAddress,
} from "../../../../store/Actions/cartActions";

/**
 * Change l'adresse par défaut, dans le même ordre que la barre de
 * navigation (Header : setDefaultAddress → fetchData → setAdd) : le
 * serveur bascule l'adresse, puis adresses, catalogue et panier sont
 * relus, et l'adresse retenue redevient l'adresse sélectionnée.
 */
const switchAddress = (address) => async (dispatch, getState) => {
  dispatch(setLoading(true));

  await dispatch(defaultAddress(address));
  await dispatch(set_OfficeAddress());
  await dispatch(setAddress());
  await dispatch(getProducts());
  await dispatch(fetchCartItem());

  const auth = getState()?.auth || {};
  const home = (auth.homeAddress || []).find((item) => item?.is_default === true);
  const office = (auth.officeAddress || []).find(
    (item) => item?.is_default === true
  );

  if (home) {
    dispatch(setSelectedAddress(home.id, "home"));
    dispatch(selectAddress("home"));
  } else if (office) {
    dispatch(setSelectedAddress(office.id, "office"));
    dispatch(selectAddress("office"));
  }

  dispatch(setLoading(false));
};

export default switchAddress;
